import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: {
    email: "",
    firstName: "",
    lastName: "",
    MCID: "",
    UID: "",
    WialonToken: "",
    ECTSCompId: "",
    COMPNAME: "",
    SYSADM: ""
  },
  consignerList: [],
  smsTemplate: [],
  transporterList: [],
  consigneeList: [],
  userList: [],
  vehicleList: [],
  vehicleType: [],
  officeList: [],
  roleList: [],
  supllierList: [],
  countryList: [],
  kpiNameList: [],
  driverList: [],
  respientList: [],
  allEntityList: [],
  latlongList: [],
  driverWithVehicle: [],
  isLoggedIn: true,
  routeList: [],
  deviceList: [],
  companyList: [],
  vehicleLists: [],
  tripMonitorData: [],
  subscriptionList:[],
  userPermissionList: [],
  AICompanyList:[],
  fenceList: [],
  nexusFenceList: [],
  myPermissionList: [],
};

export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      return {
        ...state,
        userInfo: action.payload,
      };
    },

    setUserList: (state, action) => {
      return {
        ...state,
        userList: action.payload,
      };
    },

    setSmsTemplate: (state, action) => {
      return {
        ...state,
        smsTemplate: action.payload,
      };
    },

    setConsignerList: (state, action) => {
      return {
        ...state,
        consignerList: action.payload,
      };
    },
    setTransporterList: (state, action) => {
      return {
        ...state,
        transporterList: action.payload,
      };
    },
    setConsigneeList: (state, action) => {
      return {
        ...state,
        consigneeList: action.payload,
      };
    },
    setVehicleList: (state, action) => {
      return {
        ...state,
        vehicleList: action.payload,
      };
    },
    setVehicleType: (state, action) => {
      return {
        ...state,
        vehicleType: action.payload,
      };
    },
    ssetOfficeList: (state, action) => {
      return {
        ...state,
        officeList: action.payload,
      };
    },
    setRoleList: (state, action) => {
      return {
        ...state,
        roleList: action.payload,
      };
    },
    setSupllierList: (state, action) => {
      return {
        ...state,
        supllierList: action.payload,
      };
    },
    setCountryList: (state, action) => {
      return {
        ...state,
        countryList: action.payload,
      };
    },
    setKpiNameList: (state, action) => {
      return {
        ...state,
        kpiNameList: action.payload,
      };
    },
    setDriverList: (state, action) => {
      return {
        ...state,
        driverList: action.payload,
      };
    },
    setAllEntityList: (state, action) => {
      return {
        ...state,
        allEntityList: action.payload,
      };
    },
    setRespientList: (state, action) => {
      return {
        ...state,
        respientList: action.payload,
      };
    },
    setLatLongList: (state, action) => {
      return {
        ...state,
        latlongList: action.payload,
      };
    },
    setDriverWithVehicle: (state, action) => {
      return {
        ...state,
        driverWithVehicle: action.payload,
      };
    },
    setRouteList: (state, action) => {
      return {
        ...state,
        routeList: action.payload,
      };
    },

    setDeviceList: (state, action) => {
      return {
        ...state,
        deviceList: action.payload,
      };
    },
    setCompanyList:(state, action) => {
      return {
        ...state,
        companyList: action.payload,
      };
    },
    setVehicleLists: (state, action) => {
      return {
        ...state,
        vehicleLists: action.payload,
      };
    },
    setTripMonitorData: (state, action) => {
      return {
        ...state,
        tripMonitorData: action.payload,
      };
    },
    setSubscriptionList:(state, action) => {
      return {
        ...state,
        subscriptionList: action.payload,
      };
    },
    setUserPermissionList:(state, action) => {
      return {
        ...state,
        userPermissionList: action.payload,
      };
    },
    setAICompanyList:(state, action) => {
      return {
        ...state,
        AICompanyList: action.payload,
      };
    },
    setAIVehicleLists:(state, action) => {
      return {
        ...state,
        AIVehicleLists: action.payload,
      };
    },
    setFenceList:(state, action) => {
      return {
        ...state,
        fenceList: action.payload,
      };
    },
    setNexusFenceList:(state, action) => {
      return {
        ...state,
        nexusFenceList: action.payload,
      };
    },
    setMyPermissionList:(state, action) => {
      return {
        ...state,
        myPermissionList: action.payload,
      };
    },
  },
  
});

export const {
  setTripMonitorData,
  setVehicleLists,
  setCompanyList,
  setDeviceList,
  setRouteList,
  setUserInfo,
  setUserList,
  setSmsTemplate,
  setConsignerList,
  setTransporterList,
  setConsigneeList,
  setVehicleList,
  setVehicleType,
  ssetOfficeList,
  setRoleList,
  setSupllierList,
  setCountryList,
  setKpiNameList,
  setDriverList,
  setRespientList,
  setAllEntityList,
  setLatLongList,
  setDriverWithVehicle,
  setSubscriptionList,
  setUserPermissionList,
  setAICompanyList,
  setAIVehicleLists,
  setFenceList,
  setNexusFenceList,
  setMyPermissionList
} = authSlice.actions;

export const authReducer = authSlice.reducer;
